import React, { useState, useEffect } from "react";
import MoreHorizIcon from "@material-ui/icons/MoreHoriz";
import AppMenu from "../../menu";
import TablesData from "../globalTable";
import TableItem from "../globalTable/tableItem";
import { SearchOnly } from "../globalTable/searchandfilter";
import Loader from "../../common/Loader";
import { axiosInstance } from "../../../utils/axiosInstance";
import notification from "../../common/Alert";
import ReusableRoleModal from "../modals/ReusableRoleModal";
import Button from "../../common/Button";

export default function RolesTable() {
  const [search, setSearch] = useState("");
  const [selected, setSelected] = useState([]);
  const [roles, setRoles] = useState([]);
  const [loading, setLoading] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [modalMode, setModalMode] = useState("create"); // create, edit, delete
  const [selectedRole, setSelectedRole] = useState(null);

  // Fetch roles from API
  useEffect(() => {
    const fetchRoles = async () => {
      setLoading(true);
      try {
        const response = await axiosInstance.get("/v1/admin/roles");
        setRoles(response.data?.data || []);
      } catch (error) {
        console.error("Error fetching roles:", error);
        notification.notication("error", "Failed to fetch roles", "Error");
      } finally {
        setLoading(false);
      }
    };
    fetchRoles();
  }, []);

  // Handle search input
  const handleSearch = (e) => {
    setSearch(e.target.value);
  };

  // Filter roles based on search input
  const filteredRoles = roles.filter(
    (role) =>
      role.name.toLowerCase().includes(search.toLowerCase()) ||
      role.id.toString().includes(search)
  );

  // Handle checkbox selection
  const handleClick = (id) => {
    setSelected((prev) =>
      prev.includes(id)
        ? prev.filter((selectedId) => selectedId !== id)
        : [...prev, id]
    );
  };

  // Handle select all checkboxes
  const handleSelectAll = () => {
    setSelected(
      selected.length === roles.length ? [] : roles.map((role) => role.id)
    );
  };

  // Open modal for create/edit/delete
  const openModal = (mode, role = null) => {
    setModalMode(mode);
    setSelectedRole(role);
    setModalOpen(true);
  };

  // Close modal
  const closeModal = () => {
    setModalOpen(false);
    setSelectedRole(null);
    setModalMode("create");
  };

  // Handle create/edit role
  const handleSubmitRole = async (id, payload) => {
    try {
      if (modalMode === "create") {
        const response = await axiosInstance.post("/v1/admin/roles", payload);
        setRoles([...roles, response.data.data]);
        notification.notication(
          "success",
          "Role created successfully",
          "Success",
          { timer: 3000 }
        );
      } else if (modalMode === "edit") {
        const response = await axiosInstance.put(
          `/v1/admin/roles/${id}`,
          payload
        );
        setRoles(
          roles.map((role) => (role.id === id ? response.data.data : role))
        );
        notification.notication(
          "success",
          "Role updated successfully",
          "Success",
          { timer: 3000 }
        );
      }
    } catch (error) {
      console.error(
        `Error ${modalMode === "create" ? "creating" : "updating"} role:`,
        error
      );
      throw error;
    }
  };

  // Handle delete role
  const handleDeleteRole = async (id) => {
    try {
      await axiosInstance.delete(`/v1/admin/roles/${id}`);
      setRoles(roles.filter((role) => role.id !== id));
      notification.notication(
        "success",
        "Role deleted successfully",
        "Success",
        { timer: 3000 }
      );
    } catch (error) {
      console.error("Error deleting role:", error);
      throw error;
    }
  };

  return (
    <div>
      <div
        style={{ display: "flex", alignItems: "center", marginBottom: "2rem" }}
      >
        <SearchOnly handleSearch={handleSearch} searchWord={search} />
        <Button
          onClick={() => openModal("create")}
         
        >
          Create Role
        </Button>
      </div>
      <Loader visible={loading} />
      <TableItem
        userType="Role"
        checkBoxes
        tabHeadLabel={["ID", "Role Name", "Created At", ""]}
        action
        tableSize
        tabToolBar
        tabHeadCheck
        numSelectedItem={selected.length}
        rowCount={roles.length}
        numSelected={selected.length}
        onSelectAllClick={handleSelectAll}
        tabBodyData={filteredRoles.map((role, i) => (
          <TablesData
            key={role.id}
            labelId={`enhanced-table-checkbox-${i}`}
            handleItemClick={() => handleClick(role.id)}
            aria-checked={selected.includes(role.id)}
            isItemSelected={selected.includes(role.id)}
            checkBoxes
            listItem={[
              role.id,
              <span style={{ textTransform: "capitalize" }}>{role.name}</span>,
              new Date(role.created_at).toLocaleDateString(),
              
            ]}
            action={
              <AppMenu
                menu_name_or_icon={<MoreHorizIcon />}
                item_names={[
                  { Edit: () => openModal("edit", role) },
                  { Delete: () => openModal("delete", role) },
                ]}
              />
            }
          />
        ))}
      />
      <ReusableRoleModal
        isOpen={modalOpen}
        onClose={closeModal}
        mode={modalMode}
        providerData={selectedRole}
        onSubmit={handleSubmitRole}
        onDelete={handleDeleteRole}
        roles={roles}
      />
    </div>
  );
}
